/**
 * Shims/replaces global properties/functions with project specific implementations.
 */

import { Subscription } from 'rxjs';

import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import 'pepjs';
import '@pressreader/src/shim/requestAnimation.shim';
import '@pressreader/src/shim/performance.shim';

function subscriptionDispose() {
    // eslint-disable-next-line no-console
    if (console.trace) {
        // eslint-disable-next-line no-console
        console.trace('RXJS.Subscription.dispose() is obsolete. Please use .unsubscribe() instead.');
    }

    // eslint-disable-next-line prefer-rest-params
    return Subscription.prototype.unsubscribe.apply(this, arguments);
}

(Subscription.prototype as any).dispose = subscriptionDispose;
